var pageLang = document.documentElement.lang || document.head.lang;
var alias = document.body.dataset.alias;

//возврщает день ближайшего рейса
export function getNearbyDay(nextTrip) {
  var { times, only_all_day, timezone, next_time } = nextTrip;
  var date = new Date((next_time) * 1000);

  var showClosestData = '';
  var is_night = false;

  var full_date = date.toLocaleDateString('ru-RU', { timeZone: timezone });

  var today = new Date();
  var todayDate = today.toLocaleDateString('ru-RU', { timeZone: timezone });

  var tomorrowDate = (new Date());
  tomorrowDate.setDate(today.getDate() + 1);
  tomorrowDate.toLocaleDateString('ru-RU', { timeZone: timezone });

  var dayAfterTomorrowDate = (new Date());
  dayAfterTomorrowDate.setDate(today.getDate() + 2);
  dayAfterTomorrowDate.toLocaleDateString('ru-RU', { timeZone: timezone });

  if (times?.length && !only_all_day) {
    var h_m = parseInt(times[0].split(':'));
    if (h_m >= 0 && h_m <= 3) {
      is_night = true;
    }
  }

  if (is_night) {
    if (tomorrowDate === full_date || todayDate === full_date) {
      showClosestData = (pageLang === 'ru') ? 'сегодня ночью' : 'tonight';
    } else if (dayAfterTomorrowDate === full_date) {
      showClosestData = (pageLang === 'ru') ? 'завтра ночью' : 'tomorrow night';
    } else {
      if (convert(nextTrip.next_time, nextTrip.timezone).split(' ')[1] === convert(next_time + 86400, timezone).split(' ')[1]) {
        showClosestData =
          ((pageLang === 'ru') ? 'в ночь с ' : 'On the night from ') +
          convert(nextTrip.next_time - 86400, nextTrip.timezone).split(' ')[0] +
          ((pageLang === 'ru') ? ' на ' : ' to ') +
          convert(nextTrip.next_time, nextTrip.timezone);
      } else {
        showClosestData =
          ((pageLang === 'ru') ? 'в ночь с ' : 'On the night from ') +
          convert(nextTrip.next_time - 86400, nextTrip.timezone) +
          ((pageLang === 'ru') ? ' на ' : ' to ') +
          convert(nextTrip.next_time, nextTrip.timezone);
      }
    }
  } else {
    if (todayDate === full_date) {
      showClosestData = (pageLang === 'ru') ? 'сегодня' : 'today';
    } else if (tomorrowDate === full_date) {
      showClosestData = (pageLang === 'ru') ? 'завтра' : 'tomorrow';
    } else {
      showClosestData = convert(nextTrip.next_time, nextTrip.timezone);
    }
  }

  return showClosestData;
}

//возврщает расписание - ближайший день и доступное время рейса
function getScheduleInfo(schedule) {
  var parentSchedule = schedule?.parentElement;
  var preloader = parentSchedule?.querySelector('.dke_tour__preloader');
  var text_container = parentSchedule?.querySelector('.showClosestData');
  var btns_container = parentSchedule?.querySelector('.showClosest__inner');
  var scheduleId = schedule.dataset.scheduleId;
  var page = schedule.dataset.page;

  if (parentSchedule
      && !btns_container.childElementCount
      && !preloader.classList.contains('js_dke_hidden')) {
    fetch('/ajax/next_trip?trip_id=' + scheduleId)
    .then((response) => {
      return response.json();
    }).then(function (res) {
      var showClosestData = '';

      preloader.classList.add('js_dke_hidden');

      if (res.status) {
        var buttons = [];

        var times = res.next_trip.times;

        showClosestData = text_container.innerHTML = getNearbyDay(res.next_trip);

        var button = schedule?.parentElement?.parentElement?.nextElementSibling?.querySelector('.dke_button');
        
        var data_target = button?.getAttribute('data-target');
        var is_modal = typeof data_target != 'undefined' && page != 'list';

        for (var i = 0; i < times.length; i++) {
          var time_string = times[i];

          if (is_modal) {
            buttons.push('<button class="showClosest dke_tour__ticket" data-toggle="modal" data-target="' + data_target + '" data-role="select-button">' + time_string + ' </button>');
          } else {
            buttons.push('<a class="showClosest dke_tour__ticket" href="/buy?id=' + scheduleId + '">' + time_string + ' </a>');
          }
        }

        btns_container.innerHTML += buttons.join('');
        addMoreBtn(schedule);
      }

      if (showClosestData == '') {
        const parentElementOfSchedule = schedule.parentElement;

        if (parentElementOfSchedule?.classList.contains('showClosestId')) {
          parentElementOfSchedule.style.display = 'none';
        } else if (parentElementOfSchedule?.parentElement) {
          parentElementOfSchedule.parentElement.style.display = 'none';
        }
      }
    });
  }
}

//возврщает ссылку/кнопку с текстом - день ближайшего рейса
function getScheduleDayInfo(schedule) {
  var parentSchedule = schedule?.parentElement;
  var preloader = parentSchedule?.querySelector('.dke_tour__preloader');
  var text_container = parentSchedule?.querySelector('.showClosestData');
  var scheduleId = schedule.dataset.scheduleId;
  var linkToDetail = schedule.dataset.scheduleLink;

  if (parentSchedule
      && !preloader.classList.contains('js_dke_hidden')) {
    fetch('/ajax/next_trip?trip_id=' + scheduleId)
    .then((response) => {
      return response.json();
    }).then(function (res) {
      var showClosestData = '';

      preloader.classList.add('js_dke_hidden');

      if (res.status) {
        showClosestData = getNearbyDay(res.next_trip);

        var button = schedule?.parentElement?.parentElement?.querySelector('.dke_button');
        var teplohodInfoWrapper = schedule?.parentElement?.parentElement?.querySelector('.teplohod-info-wrapper');

        var data_target = button?.getAttribute('data-target');
        var is_modal = !!data_target;
        
        if (linkToDetail) {
          text_container.innerHTML = '<a class="offer-link showClosest" href="' + linkToDetail + '">' + showClosestData + ' </a>';
        } else if (teplohodInfoWrapper) {
          text_container.innerHTML = '<div class="showClosest">' + showClosestData + ' </div>';
        } else if (is_modal) {
          text_container.innerHTML = '<button type="button" class="offer-link showClosest" data-toggle="modal" data-target="' + data_target + '" data-role="select-button">' + showClosestData + ' </button>';
        } else {
          text_container.innerHTML = '<a class="offer-link showClosest" href="/buy?id=' + scheduleId + '">' + showClosestData + ' </a>';
        }
      }
      if (showClosestData == '') {
        parentSchedule.style.display = 'none';
      }
    });
  }
}
function convert(unixtimestamp, timezone) {
  var months_arr = {
      ru: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
      en: ['January', 'Febraury', 'March', 'April', 'May', 'June', 'July', 'August ', 'September', 'October', 'November', 'December']
  };

  var date = new Date(unixtimestamp * 1000);

  //var time_string = date.toLocaleDateString('ru-RU', { timeZone: timezone });
  var date_parsed = date.toLocaleDateString('ru-RU', { timeZone: timezone }).split('.');

  var month_number = parseInt(date_parsed[1]) - 1;

  if (!months_arr.hasOwnProperty(pageLang)) {
    pageLang = 'en';
  }

  var month = months_arr[pageLang][month_number];
  var day = date_parsed[0];

  return day + ' ' + month;
}

function addMoreBtn($schedule) {
  var links = Array.from($schedule.parentElement.querySelectorAll('.showClosest__inner .showClosest'));

  if (links.length > 5) {
    for (let i = 5; i < links.length; i++) {
      links[i].classList.add('js_dke_tour__ticket_hidden');
    }

    var moreBtn = document.createElement('button')
    moreBtn.classList.add('showClosest', 'dke_tour__ticket');
    moreBtn.innerText = (pageLang === 'ru') ? 'ещё...' : 'more...';
    moreBtn.addEventListener('click', function () {
      moreBtn.style.display = 'none';

      for (let i = 5; i < links.length; i++) {
        links[i].classList.remove('js_dke_tour__ticket_hidden');
      }
    });

    links[4].after(moreBtn);
  }
}

function getScheduleArr(scheduleInfoArr) {
  if (scheduleInfoArr?.length) {
    for (const scheduleInfo of scheduleInfoArr) {
      getScheduleInfo(scheduleInfo);
    }
  }
}

function getScheduleDayArr(scheduleInfoArr) {
  if (scheduleInfoArr?.length) {
    for (const scheduleInfo of scheduleInfoArr) {
      getScheduleDayInfo(scheduleInfo);
    }
  }
}

function onScrollSchedule(tours) {
  if (tours?.length) {
    const currentScrollPosition = window.pageYOffset + window.innerHeight;

    tours.forEach((tour, index, arrTours) => {
      const scrollPositionSchedule = window.pageYOffset + tour.getBoundingClientRect().top;
      
      if (currentScrollPosition >= scrollPositionSchedule) {
        const scheduleInfo = tour?.querySelector('.schedule');
        if (scheduleInfo) {
          getScheduleInfo(scheduleInfo);
        }
        arrTours.splice(index, 1);
      }
    });
  }
}

export function getScheduleForTour() {
  const schedule = document.querySelector('.dke_tour-features .schedule');
  if (schedule) {
    getScheduleInfo(schedule);
  }
}

export function getSchedule() {
  const tours = Array.from(document.querySelectorAll('.dke_tour'));
  const scheduleInfoArr = tours.map(tour => {
    return tour.querySelector('.schedule');
  });
  const filterBtnSubmit = document.querySelector('#filter__btn_submit');
  const filterBtnReset = document.querySelector('#filter__btn_reset');

  window.addEventListener('scroll', function() {
    onScrollSchedule(tours);
  });

  filterBtnSubmit?.addEventListener('click', function() {
    setTimeout(function() {
      getScheduleArr(scheduleInfoArr);
    }, 250);
  });

  filterBtnReset?.addEventListener('click', function() {
    setTimeout(function() {
      getScheduleArr(scheduleInfoArr);
    }, 250);
  });
}

export function getClosestDayForOffers() {
  const scheduleInfoArr = Array.from(document.querySelectorAll('.dke_tours-offer .schedule'));
  
  getScheduleDayArr(scheduleInfoArr);
}
